import _typeof from "./typeof.js";
import toPrimitive from "./toPrimitive.js";
export default function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/toPropertyKey.js
// module id = 971
// module chunks = 1